import axios from 'axios';
import API_URL from '../config/api';

// Função auxiliar para obter headers com token
const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// ============================================
// TEMPLATES
// ============================================

export const listarTemplates = async () => {
  try {
    const response = await axios.get(`${API_URL}/templates`, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao listar templates:', error);
    throw error;
  }
};

export const buscarTemplate = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/templates/${id}`, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar template:', error);
    throw error;
  }
};

export const criarTemplate = async (dados) => {
  try {
    const response = await axios.post(`${API_URL}/templates`, dados, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao criar template:', error);
    throw error;
  }
};

export const atualizarTemplate = async (id, dados) => {
  try {
    const response = await axios.put(`${API_URL}/templates/${id}`, dados, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar template:', error);
    throw error;
  }
};

export const excluirTemplate = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/templates/${id}`, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao excluir template:', error);
    throw error;
  }
};

export const alternarStatusTemplate = async (id) => {
  try {
    const response = await axios.patch(`${API_URL}/templates/${id}/status`, {}, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao alternar status:', error);
    throw error;
  }
};

// ============================================
// CONTRATOS DE ALUGUEL
// ============================================

export const listarContratosAluguel = async (filtros = {}) => {
  try {
    const params = new URLSearchParams(filtros).toString();
    const response = await axios.get(`${API_URL}/contratos-aluguel?${params}`, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao listar contratos:', error);
    throw error;
  }
};

export const buscarContratoAluguel = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/contratos-aluguel/${id}`, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar contrato:', error);
    throw error;
  }
};

export const gerarContrato = async (dados) => {
  try {
    const response = await axios.post(`${API_URL}/contratos-aluguel/gerar`, dados, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao gerar contrato:', error);
    throw error;
  }
};

export const atualizarContratoAluguel = async (id, dados) => {
  try {
    const response = await axios.put(`${API_URL}/contratos-aluguel/${id}`, dados, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar contrato:', error);
    throw error;
  }
};

export const cancelarContrato = async (id, observacoes) => {
  try {
    const response = await axios.patch(`${API_URL}/contratos-aluguel/${id}/cancelar`, { observacoes }, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao cancelar contrato:', error);
    throw error;
  }
};

export const excluirContratoAluguel = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/contratos-aluguel/${id}`, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao excluir contrato:', error);
    throw error;
  }
};

export const listarHistorico = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/contratos-aluguel/${id}/historico`, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao listar histórico:', error);
    throw error;
  }
};

// ============================================
// ASSINATURA PÚBLICA
// ============================================

export const visualizarContratoPorToken = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/publico/contrato/${token}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao visualizar contrato:', error);
    throw error;
  }
};

export const assinarContrato = async (token, assinaturaDigital) => {
  try {
    const response = await axios.post(`${API_URL}/publico/contrato/${token}/assinar`, {
      assinatura_digital: assinaturaDigital
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao assinar contrato:', error);
    throw error;
  }
};

// ============================================
// CONTRATOS (Sistema atual)
// ============================================

export const listarContratos = async () => {
  try {
    const response = await axios.get(`${API_URL}/contratos`, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao listar contratos:', error);
    throw error;
  }
};

export const excluirContrato = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/contratos/${id}`, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao excluir contrato:', error);
    throw error;
  }
};

export const reenviarContrato = async (id, opcoes) => {
  try {
    const response = await axios.post(`${API_URL}/contratos/${id}/reenviar`, opcoes, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao reenviar contrato:', error);
    throw error;
  }
};

// ============================================
// CONFIGURACOES DE CONTRATOS
// ============================================

export const buscarConfiguracoesContratos = async () => {
  try {
    const response = await axios.get(`${API_URL}/contratos/configuracoes`, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar configuracoes de contratos:', error);
    throw error;
  }
};

export const atualizarConfiguracoesContratos = async (dados) => {
  try {
    const response = await axios.put(`${API_URL}/contratos/configuracoes`, dados, {
      headers: getHeaders()
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar configuracoes de contratos:', error);
    throw error;
  }
};
